import * as type from './types'
import actions from './actions'
const state = {
  info: {},
  isLoggedIn: false,
  role: null,
  id: '',
  token: '',
}
const mutations = {
  [type.STORE_USER] (state, payload) {
    state.info = payload.user
    state.isLoggedIn = true
    state.role = payload.user.roles[0].name
    state.token = payload.accessToken
    state.id = payload.user.id
  },
  [type.LOGOUT] (state) {
    state.info = {}
    state.isLoggedIn = false
    state.role = null
    state.id = ''
    state.token = ''
  },
}
export default {
  actions,
  state,
  mutations,
}
